import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  iconFolder: "VBZ", // Overrides the public/static/images/<config.id>
  id: "postauto",
  industry: IndustryEnum.Transport,
  name: "PostAuto",
  settings: {
    stops_api_bbox: "5.657959,45.675482,10.722656,47.908978",
    stops_api_prefagencies: "sbb",
  },
  slug: "postauto",
  ...colors,
};
export default config;
